<template>
    <custom-modal title="Leave Document" v-model="show" @close="close()" :loading="loading" :width="1080">
        <div v-if="items.length">
            <file-share-upload
                class="mb-2"
                :path="`/upload-file-share-model/hrms_files/StaffFile`"
                v-if="!form.file_id"
                @uploaded="uploaded"
                :moreDetails="moreInfo"
            ></file-share-upload>
            <div v-if="form.file_id && form.file">
                <a :href="form.file.url" target="_blank">{{form.file.name}}</a>
            </div>

            <v-simple-table dense>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Applied At</th>
                        <th>From</th>
                        <th>To</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items" :key="item.iRequestID">
                        <td>{{ item.iRequestID }}</td>
                        <td>{{ item.leave_type.cEngLeaveName }}</td>
                        <td v-html="item.cDhiReason"></td>
                        <td>{{ $localeDateTime(item.dtAppliedDate) }}</td>
                        <td>{{ $localeDate(item.dtLeaveFrom) }}</td>
                        <td>{{ $localeDate(item.dtLeaveTo) }}</td>
                        <td>
                            <v-checkbox :value="item.iRequestID" v-model="form.requested_leaves"></v-checkbox>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </div>

        <v-alert v-else border="top" type="info" elevation="2" colored-border>
            No uncertified leaves eligible to upload documents. Leaves that are eligible to upload documents will show up below.
        </v-alert>

        <template #actions>
            <!-- <v-btn small outlined :disabled="form.requested_leaves && !form.requested_leaves.length && !!form.file_id" @click="save">add document</v-btn> -->
            <v-btn small outlined :disabled="!isFilled" @click="save">add document</v-btn>
        </template>
    </custom-modal>
</template>

<script>
import CustomModal from '../util/CustomModal.vue'
import FileShareUpload from '../util/file_upload/FileShareUpload.vue'

export default {
    components: {CustomModal, FileShareUpload},
    data: () => ({
        show: false,
        loading: false,
        ismid: '',
        items: [],
        form: {
            requested_leaves: [],  
            file_id: '',
        },
        moreInfo: {path: 'leave_documents'},
    }),
    computed: {
        isFilled() {
            return this.items.length && this.form.file_id && this.form.requested_leaves.length
        }
    },
    methods: {
        save() {
            this.loading  = true
            this.$axios.post(`/api/leave-documents/saveLeaveDocument`, this.form).then((resp) => {
                this.close()
            }).finally(() => this.loading = false)
        },
        uploaded(data) {
            this.form.file_id = data.id
            this.loading = true
            this.$axios.get(`/api/files/${this.form.file_id}`).then((resp) => {
                this.form.file = resp.data
            }).finally(() => {
                this.loading = false
            })
        },
        getItems() {
            this.loading = true
            this.$axios.get(`/api/leave-documents/staff/${this.ismid}/getDocumentRequiredLeaves`).then((resp) => {
                this.items = resp.data
            }).finally(() => this.loading = false)
        },
        open(ismid) {
            this.ismid = ismid
            this.getItems()
            this.show = true
        },
        close() {
            this.$emit('reload')
            this.resetData()
        },
        resetData() {
            Object.assign(this.$data, this.$options.data())
        },
    },
}
</script>

<style>

</style>